import React, { useState } from "react";
import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    Paper,
    TextField,
    Typography,
} from "@mui/material";
import { AddCircle, CurrencyRupee, RemoveCircle } from "@mui/icons-material";
import authService from "../../Auth/AuthService";
import { useNavigate } from "react-router-dom";

function FeesentryForm({ classRoom, masterId, onSuccess }) {
    const [fees, setFees] = useState([
        { feeType: "", amount: classRoom?.paidAmount || "" },
    ]);

    const [commonData, setCommonData] = useState({
        studentId: classRoom?.studentId || null,
        classRoomId: classRoom?.classId || null,
        standard: classRoom?.standard || null,
        annualFees: classRoom?.annualfee || null,
        paymentDate: "",
        paymentMode: "",
        paidAmount: classRoom?.paidAmount || "",
        discountAmount: "",
    });

    const [openForm, setOpenForm] = useState(true);
    const navigate = useNavigate();
    const handleFeeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedFees = [...fees];
        updatedFees[index][name] = value;
        setFees(updatedFees);
    };

    const handleCommonChange = (e) => {
        const { name, value } = e.target;
        setCommonData((prev) => ({ ...prev, [name]: value }));
    };

    const addFees = () => {
        setFees([...fees, { feeType: "", amount: "" }]);
    };

    const removeFees = (index) => {
        const updatedFees = fees.filter((_, i) => i !== index);
        setFees(updatedFees);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (classRoom?.classId === null) {
            return;
        }

        const paid = fees.reduce((sum, fee) => sum + Number(fee.amount), 0).toFixed(2);
        const finalData = { ...commonData, fees, paidAmount: paid };
        // console.log("Submitted Fees:", finalData);
        try {
            const url = authService.pathUrl('POST', '/fees')
            const resFee = await authService.postAuth(url, finalData)
            const url1 = authService.pathUrl('GET', '/schools/email')
            const resSch = await authService.getAuth(url1);
            const DOC_URL = authService.DOC_URL;
            const data = {
                schoolName: resSch?.schoolName,
                logo: DOC_URL + resSch?.logoUrl,
                address: [resSch.addressDTO?.addressLine1, resSch.addressDTO?.city, resSch.addressDTO?.state]
                    .filter(Boolean) // removes null/undefined/empty
                    .join(", "),
                studentName: classRoom?.studentName,
                receiptNumber: classRoom?.classId, //resFee?.id,
                ...finalData,
            };
            sessionStorage.setItem("hide", false);
            navigate('/payment-receipt', {
                state: {
                    receiptData: data
                },
            });
            if (onSuccess) onSuccess();
            setOpenForm(false)
        } catch (error) {
            console.error("Error posting fees :", error);
        }

    };

    return (
        <Paper sx={{ p: 0, maxWidth: 800, mx: "auto", borderRadius: 3 }}>
            {openForm && (
                <Box>
                    <Typography variant="h6" sx={{ px: 2 }} color="#3f2d01" fontWeight={'bold'}>
                        <CurrencyRupee sx={{ mr: 1, mb: -0.5 }} />
                        Add Fees
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    <form onSubmit={handleSubmit}>
                        <Box>
                            {/* Fee rows */}
                            {fees.map((fee, index) => (
                                <Grid container spacing={2} key={index} alignItems="center" sx={{ mb: 2 }}>
                                    <Grid item xs={5}>
                                        <TextField
                                            fullWidth
                                            label="Fee Type"
                                            name="feeType"
                                            value={fee.feeType}
                                            onChange={(e) => handleFeeChange(index, e)}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Amount"
                                            name="amount"
                                            value={fee.amount}
                                            onChange={(e) => handleFeeChange(index, e)}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        {index > 0 && (
                                            <IconButton color="error" onClick={() => removeFees(index)}>
                                                <RemoveCircle />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </Grid>
                            ))}

                            {/* Add new fee type/amount */}
                            <Button startIcon={<AddCircle />} onClick={addFees} sx={{ mt: 1, mb: 3, color: '#3f2d01', fontWeight: 'bold' }}>
                                Add Fee
                            </Button>

                            {/* Common fields */}
                            <Grid container spacing={2} sx={{ mt: 1 }}>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Payment Mode"
                                        name="paymentMode"
                                        value={commonData.paymentMode}
                                        onChange={handleCommonChange}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        label="Payment Date"
                                        name="paymentDate"
                                        value={commonData.paymentDate}
                                        onChange={handleCommonChange}
                                        required
                                        slotProps={{
                                            inputLabel: { shrink: true }
                                        }}
                                    />
                                </Grid>
                                {/* <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Discount Amount"
                                        name="discountAmount"
                                        value={commonData.discountAmount}
                                        onChange={handleCommonChange}
                                    />
                                </Grid> */}

                                {/* <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Remarks"
                                        name="remarks"
                                        value={commonData.remarks}
                                        onChange={handleCommonChange}
                                    />
                                </Grid> */}
                            </Grid>

                            {/* Save button */}
                            <Grid item xs={12} sx={{ mt: 3 }}>
                                <Button
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    sx={{ py: 1, fontWeight: "bold", bgcolor: "#3f2d01", borderRadius: 5 }}
                                >
                                    Save Fees
                                </Button>
                            </Grid>
                        </Box>
                    </form>
                </Box>

            )}
        </Paper>
    );
}

export default FeesentryForm;
